import { useTranslation } from 'next-i18next'
import { makeStyles, Container } from '@material-ui/core'
import T from '../../home-new/tokens'
import Reveal from '../../home-new/Reveal'

// "บริการหลักของ SHIPPOP" — 4 white cards, each a core PNG icon + brand-blue
// title + muted desc + a dark pill link button. Icon→card mapping matches the
// design (domestic / international / SHIPPOP Business / API, Plugin & Module).
// Copy is i18n-keyed under services.new.core.* (title/desc/cta per card).
const cards = [
  { key: 'card1', icon: '/static/img/service-new/v2/core/domestic.png', href: '/checkprice' },
  { key: 'card2', icon: '/static/img/service-new/v2/core/intl.png', href: '/checkprice' },
  { key: 'card3', icon: '/static/img/service-new/v2/core/business.png', href: '/business' },
  { key: 'card4', icon: '/static/img/service-new/v2/core/api.png', href: '/business#connect' },
]

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '70px 0',
    background: T.color.canvas,
    [theme.breakpoints.down('sm')]: { padding: '44px 0' },
  },
  heading: {
    fontFamily: T.font.heading,
    fontSize: 32,
    fontWeight: 700,
    color: T.color.ink,
    textAlign: 'center',
    margin: '0 0 44px',
    '& span': { color: T.color.brand },
    [theme.breakpoints.down('sm')]: { fontSize: 22, margin: '0 0 28px' },
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '24px',
    [theme.breakpoints.down('md')]: { gridTemplateColumns: 'repeat(2, 1fr)' },
    [theme.breakpoints.down('xs')]: { gridTemplateColumns: '1fr', gap: '18px' },
  },
  card: {
    background: T.color.surface,
    borderRadius: 24,
    boxShadow: T.shadow.card,
    padding: '34px 24px 28px',
    textAlign: 'center',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    transition: 'transform 0.25s ease, box-shadow 0.25s ease',
    '&:hover': { transform: 'translateY(-4px)', boxShadow: '0 16px 36px rgba(0,102,204,0.14)' },
  },
  iconWrap: {
    height: 84,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 16,
    '& img': { maxHeight: 84, maxWidth: 120, objectFit: 'contain' },
  },
  cardTitle: {
    fontFamily: T.font.heading,
    fontSize: 20,
    fontWeight: 600,
    color: T.color.brand,
    margin: '0 0 12px',
    minHeight: 56,
    whiteSpace: 'pre-line',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: { fontSize: 18, minHeight: 'auto' },
  },
  cardDesc: {
    fontFamily: T.font.body,
    fontSize: 14.5,
    color: T.color.muted,
    lineHeight: 1.65,
    margin: '0 0 24px',
    flexGrow: 1,
  },
  cardBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 44,
    minWidth: 168,
    padding: '0 20px',
    borderRadius: T.radius.pill,
    background: T.color.ink,
    color: T.color.onBrand,
    fontFamily: T.font.heading,
    fontSize: 15,
    fontWeight: 500,
    textDecoration: 'none',
    transition: 'transform 0.2s ease, background 0.2s ease',
    '&:hover': { transform: 'translateY(-2px)', background: T.color.brandDeep, color: T.color.onBrand },
  },
}))

const CoreServices = () => {
  const classes = useStyles()
  const { t } = useTranslation('services')
  return (
    <section className={classes.root} id="core-services">
      <Container maxWidth={false} style={{ maxWidth: T.container }}>
        <Reveal>
          <h2 className={classes.heading}>
            {t('new.core.heading-lead')}
            <span>{t('new.core.heading-brand')}</span>
          </h2>
        </Reveal>
        <div className={classes.grid}>
          {cards.map((c, i) => (
            <Reveal key={c.key} delay={i * 0.1}>
              <div className={classes.card}>
                <span className={classes.iconWrap}>
                  <img src={c.icon} alt="" aria-hidden="true" loading="lazy" />
                </span>
                <h3 className={classes.cardTitle}>{t(`new.core.${c.key}.title`)}</h3>
                <p className={classes.cardDesc}>{t(`new.core.${c.key}.desc`)}</p>
                <a href={c.href} className={classes.cardBtn}>
                  {t(`new.core.${c.key}.cta`)}
                </a>
              </div>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  )
}

export default CoreServices
